export default "__VITE_ASSET__DrQMghGr__"